export const LANGUAGES = {
  en: { code: 'en', prefix: '', hreflang: 'en', locale: 'en-US', label: 'English', shortLabel: 'English' },
  es: { code: 'es', prefix: '/es', hreflang: 'es', locale: 'es-ES', label: 'Español', shortLabel: 'Español' },
  pt: { code: 'pt', prefix: '/pt', hreflang: 'pt-BR', locale: 'pt-BR', label: 'Português', shortLabel: 'Português' },
  fr: { code: 'fr', prefix: '/fr', hreflang: 'fr', locale: 'fr-FR', label: 'Français', shortLabel: 'Français' },
  it: { code: 'it', prefix: '/it', hreflang: 'it', locale: 'it-IT', label: 'Italiano', shortLabel: 'Italiano' },
};

export const LANGUAGE_CODES = Object.keys(LANGUAGES);

export function normalizeLanguage(language) {
  return Object.prototype.hasOwnProperty.call(LANGUAGES, language) ? language : 'en';
}

export function getLanguageConfig(language) {
  return LANGUAGES[normalizeLanguage(language)];
}

export function getLanguagePrefixes() {
  return LANGUAGE_CODES.map((code) => LANGUAGES[code].prefix);
}
